/**
 * Progress Status (今期進捗状況) tab definitions.
 *
 * `key` is the local/UI tab id. `metric` is the wire value sent as the
 * `metric` query param of GET /api/summary/progress/term; the server
 * whitelists exactly `revenue | operatingProfit | recurringProfit | netIncome`
 * and maps each to its RKD columns (RTLR_c/VOPP_c/VRRP_c/NINC_c) internally.
 * `estimateType` is the IBES estimate_type the server pairs with the metric,
 * kept here for traceability only.
 */
export const PROGRESS_METRICS = {
  revenue: {
    key: 'revenue',
    displayLabel: '売上高',
    metric: 'revenue',
    estimateType: 'REVENUE',
  },
  operating: {
    key: 'operating',
    displayLabel: '営業利益',
    metric: 'operatingProfit',
    estimateType: 'OPP',
  },
  ordinary: {
    key: 'ordinary',
    displayLabel: '経常利益',
    metric: 'recurringProfit',
    estimateType: 'PTP',
  },
  net: {
    key: 'net',
    displayLabel: '当期利益',
    metric: 'netIncome',
    estimateType: 'NTPREP',
  },
} as const;

export type ProgressMetricKey = keyof typeof PROGRESS_METRICS;
export type ProgressMetricSelection =
  (typeof PROGRESS_METRICS)[ProgressMetricKey];

export const DEFAULT_PROGRESS_METRIC_KEY: ProgressMetricKey = 'ordinary';

export const getProgressMetric = (
  key: string | undefined,
): ProgressMetricSelection => {
  if (
    key &&
    Object.prototype.hasOwnProperty.call(PROGRESS_METRICS, key)
  ) {
    return PROGRESS_METRICS[key as ProgressMetricKey];
  }

  return PROGRESS_METRICS[DEFAULT_PROGRESS_METRIC_KEY];
};
